<template>
  <main>
    <div :class="groupClasses" @click="toggleGroup(item)">
      <s-icon v-if="item.icon" :icon="item.icon" size="medium" :color="groupColor" />
      <transition>
        <div class="sidebar-item-text text-wrap" v-if="drawer">
          <span>{{ item.title }}</span>
          <s-icon :icon="item.expanded ? 'mdiChevronUp' : 'mdiChevronDown'" size="small" />
        </div>
      </transition>
    </div>
    <transition name="opacity" mode="out-in" :duration="100">
      <div v-if="item.expanded" class="sidebar-sub-items" v-show="drawer">
        <div v-for="(tab, index) in tabs" :key="index" :class="{'sidebar-sub-item': true, 'selected': tab.active}" @mousedown="(event: any) => handleMouseDown(event, item.route, tab.route)"    @click="goToPage(item.route, tab.route)">
          <span>{{ tab.title }}</span>
        </div>
      </div>
    </transition>
  </main>
</template>

<script lang="ts" setup>
import type { Usuario } from '~/@types/schemas/usuario';


interface SidebarGroupProps {
  item: Page;
  drawer: boolean;
  user: Usuario;
  toggleGroup: (item: Page) => void;
  goToPage: (...routes: string[]) => void;
}

const props = defineProps<SidebarGroupProps>();

const groupClasses = computed(() => ({
  'sidebar-item': true,
  'selected': props.item.active,
  'expanded': props.item.expanded
}));

const groupColor = computed(() => props.item.active ? props.item.color : resolvedColor('base-icon'));

const tabs = computed(() => {
  if (!props.user) return;

  const availableTabs = props.item.tabs || [];
  
  return getAllowedPages(availableTabs);
});

const handleMouseDown = (event: MouseEvent, itemRoute: string, tabRoute: string) => {
  if (event.button === 1) { 
    const fullRoute = `${itemRoute}/${tabRoute}`;
    window.open(fullRoute, '_blank');
  }
};

</script>
